
import type { PropOptions } from 'vue';
import Vue from 'vue';
import MoreIcon from '@/assets/svg/more.vue.svg';
import Dropdown from '~/components/common/Dropdown/Dropdown.vue';
import DropdownMenu from '~/components/common/Dropdown/DropdownMenu.vue';
import DropdownItem from '~/components/common/Dropdown/DropdownItem.vue';

export default Vue.extend({
  name: 'PendingTestimonial',
  components: { Dropdown, DropdownMenu, DropdownItem, MoreIcon },
  props: {
    authorName: {
      type: String,
      default: '',
    } as PropOptions<string>,
    authorEmail: {
      type: String,
      default: '',
    } as PropOptions<string>,
    stateName: {
      type: String,
      required: true,
    } as PropOptions<'requested' | 'verifying'>,
  },
  computed: {
    stateClass(): string[] {
      return ['pending-testimonial__state', `pending-testimonial__state--${this.stateName}`];
    },
  },
});
